// extracted by mini-css-extract-plugin
module.exports = {"cell":"Rows_cell__Q5BhO","icon":"Rows_icon__3slfN","linkIcon":"Rows_linkIcon__3A2k9","badge":"Rows_badge__Fr_I9","row":"Rows_row__3d91W"};